import { Grid, Typography, Tooltip, useTheme } from "@mui/material";

import InfoIcon from "@mui/icons-material/Info";

import { CategoriesAvatar } from "@aclymatepackages/atoms";
import { subcategories } from "@aclymatepackages/subcategories";

const HeaderDisplay = ({ transactionSubcategory }) => {
  const { palette } = useTheme();

  const { name: selectedSubcategoryName = "Other Emissions", description } =
    subcategories.find(
      ({ subcategory }) => subcategory === transactionSubcategory
    ) || {};

  return (
    <Grid container spacing={1} alignItems="center" wrap="nowrap">
      <Grid item>
        <CategoriesAvatar subcategory={transactionSubcategory} />
      </Grid>
      <Grid item>
        <Typography variant="body1">{selectedSubcategoryName}</Typography>
      </Grid>
      {description && (
        <Grid item>
          <Tooltip title={description}>
            <InfoIcon style={{ color: palette.text.secondary }} />
          </Tooltip>
        </Grid>
      )}
    </Grid>
  );
};
export default HeaderDisplay;
